/**
 * src/components/cologDocsApi.js
 *
 * Fetch wrappers for the CO Log change-order-document endpoints, now served by
 * Azure Functions (cologCoDocs / cologVerifySignature) instead of the localserver
 * expenseServer. Tells the CO Log which change-order documents are filed in a
 * job's SharePoint folder, and runs the signature verifier.
 *
 * Uses the same env-aware Azure-Functions base URL as AISummary / company.js.
 */

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://forecastingprodservice.azurewebsites.net/'
    : 'https://forecastingtestservice.azurewebsites.net/')
).replace(/\/?$/, '/');

// getCoDocs(job) -> {
//   job, siteFound, folderFound, folderUrl, fileCount,
//   files: [{ name, size, webUrl, lastModified }],
//   subfolders: [{ name, childCount }]
// }
export const getCoDocs = async (job) => {
  if (!job) return null;
  const url = `${API_BASE}api/cologCoDocs?job=${encodeURIComponent(job)}`;
  const r = await fetch(url, { credentials: 'omit' });
  if (!r.ok) throw new Error(`cologCoDocs ${r.status}`);
  return r.json();
};

// verifyCoSignature({ job, co, signedDate, description }) -> {
//   job, co, key, signedDate, fusionDate,
//   status: 'signed' | 'date_mismatch' | 'unsigned' | 'no_doc',
//   source: 'form' | 'email' | null,
//   hasSignedDoc, fileName, webUrl,
//   clientSigned, clientSignedDate, docDate, dateSource, dateMatches,
//   confidence, extracted, emailApprover
// }
// Runs the verifier on the CO's signed PDF — or, when there's no signed form, an
// approval email — in SharePoint. Side-effecting (model run) so it's a POST.
// `description` helps the model judge whether an email is about this CO. Caller
// persists the result via updateUserDataArray.
export const verifyCoSignature = async ({ job, co, signedDate, description }) => {
  if (!job || !co) return null;
  const r = await fetch(`${API_BASE}api/cologVerifySignature`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'omit',
    body: JSON.stringify({ job, co, signedDate, description }),
  });
  if (!r.ok) throw new Error(`cologVerifySignature ${r.status}`);
  return r.json();
};
